import React, { useState, useEffect, useContext } from 'react';
import * as Yup from 'yup';
import {
    CrudMasterDetailView,
    GridView,
    Widget,
    FormSubmitButton,
    CompositeView,
    MasterDetailForm,
    FormatText,
    FormTextArea,
    CrudContext,
    useRouter,
    Row,
    Col,
    FormNumber,
    Button,
} from '@digital/ui';
import UploadFile from '@app/components/uploadFile';

import {
    CrfCicloOrcamentario,
    CrfCicloOrcamentarioHasJoinProjeto,
    getAllCrfCicloOrcamentario,
    createCrfCicloOrcamentario,
    getAllCrfCicloOrcamentarioHasTap,
    updateCrfCicloOrcamentario,
    createPlanilhaTpaCrfCicloOrcamentario,
    exportaCrfCicloOrcamentarioAno,
} from '@app/api/crf/crfcicloorcamentario';

import CrfCicloOrcamentarioTable from './CrfCicloOrcamentarioTable';
import { hasPermission } from '@app/helpers/permissions';
import { exportaCrfModelo } from '@app/api/crf/crfExportaFile';
import { EExportarModeloCrf } from '@app/enums/EExportarModeloCrf';

const validationSchema = Yup.object().shape({
    ano: Yup.string()
        .required('Ano deve ser informado')
        .max(5, 'O Ano deve ter no máximo 4 caracteres.')
        .nullable(),
    descricao: Yup.string().max(2000, 'Notas deve ter no máximo 2000 caracteres.'),
});

const CrfCicloOrcamentarioComponent = () => {
    const { history } = useRouter();
    const { selectedItem } = useContext(CrudContext);
    const [ciclos, setCiclos] = useState(() => getAllCrfCicloOrcamentario);
    const [projetos, setProjetos] = useState<CrfCicloOrcamentarioHasJoinProjeto[]>();
    const [hasFile, setHasFile] = useState(true);

    useEffect(() => {
        listarCrfCiclosOrcamentarios();
    }, []);

    const listarCrfCiclosOrcamentarios = () => {
        setCiclos(() => Promise.resolve(undefined));
        setCiclos(() => getAllCrfCicloOrcamentario);
    };

    const onCreateCrfCicloOrcamentario = (ciclo: CrfCicloOrcamentario) => {
        return createCrfCicloOrcamentario(ciclo)
            .then((resp: any) => {
                if (resp.valid) {
                    listarCrfCiclosOrcamentarios();
                    window.location.href = `/CrFch/cicloOrcamentario/detail/${resp && resp.id}`;
                }
                return resp;
            });
    };

    const handleCreatePlanilhaTpa = (values: any, selectedItem: any) => {
        if (!selectedItem) {
            const ciclo: CrfCicloOrcamentario = {
                id: values.id,
                nome: values.nome,
                descricao: values.descricao ? values.descricao : '',
                ano: values.ano,
            };
            onCreateCrfCicloOrcamentario(ciclo);
        } else {
            createPlanilhaTpaCrfCicloOrcamentario(selectedItem.id, values.formData, values)
                .then((result: any) => {
                    if (result && result.valid) {
                        setHasFile(true);
                        setHasFile(false);
                        setCiclos(() => Promise.resolve(undefined));
                        setCiclos(() => getAllCrfCicloOrcamentario);
                        handleJoinProjeto(selectedItem.id);
                    }
                });
        }
    };

    const onUpdateCrfCicloOrcamentario = (ciclo: CrfCicloOrcamentario) => {
        return updateCrfCicloOrcamentario(ciclo)
            .then((resp: any) => {
                if (resp.valid) {
                    listarCrfCiclosOrcamentarios();
                }
                return resp;
            });
    };


    const handleJoinProjeto = async (CId: string) => {
        const result = await getAllCrfCicloOrcamentarioHasTap(CId);
        if (result) {
            setProjetos(result);
        }
    };


    return (
        <CrudMasterDetailView
            getAllItems={ciclos}
            createItem={hasPermission(['CICLO_ORCAMENTARIO_CADASTRAR']) ? onCreateCrfCicloOrcamentario : undefined}
            updateItem={hasPermission(['CICLO_ORCAMENTARIO_EDITAR']) ? onUpdateCrfCicloOrcamentario : undefined}
            disableNotification
            icon="business-process"
            detailTitleExtractor={item => `${item.ano}`}
            filterPredicate={(item, value) =>
                (item.descricao && item.descricao.toLowerCase().includes(value.toLowerCase())) ||
                (item.ano !== undefined &&
                    item.ano
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase()))
            }
            titleExtractor={item => `${item.ano}`}
            descriptionExtractor={item => ''}>
            <CompositeView>
                {hasPermission(['MODULO_CADASTRO_BASICO_VISUALIZAR_MENU']) && (
                    <CrudContext.Consumer>
                        {({ selectedItem }) => {
                            return (
                                <GridView noform>
                                    <MasterDetailForm
                                        validationSchema={validationSchema}
                                        onSubmit={values => {
                                            handleCreatePlanilhaTpa(values, selectedItem);
                                        }}>
                                        <Widget
                                            title="Dados do Ciclo Orçamentário"
                                            actions={[
                                                selectedItem && hasPermission(['CICLO_ORCAMENTARIO_EDITAR']) && (
                                                    [
                                                        <Button
                                                            type="link"
                                                            icon="files-xls"
                                                            onClick={() => {
                                                                exportaCrfModelo(EExportarModeloCrf.MODELO_IMPORTACAO_TAP);
                                                            }}>
                                                            Modelo de importação Finplan
                                                        </Button>,
                                                        <Button
                                                            type="primary"
                                                            size={'small'}
                                                            icon="files-ms_excel"
                                                            onClick={() => {
                                                                if (selectedItem)
                                                                    exportaCrfCicloOrcamentarioAno(selectedItem.id)
                                                            }}>
                                                            Exporta Relatório
                                                        </Button>
                                                    ]
                                                ),

                                                hasPermission(['CICLO_ORCAMENTARIO_CADASTRAR', 'CICLO_ORCAMENTARIO_EDITAR']) && (
                                                    <FormSubmitButton type="primary">
                                                        <FormatText id="ui.commons.save" uppercase />
                                                    </FormSubmitButton>
                                                ),
                                            ]}>
                                            <FormNumber label="Ano" name="ano" span={2} disabled={selectedItem && selectedItem.id} />
                                            <FormTextArea label="Notas" placeholder="" name="descricao" rows={3} />
                                            {selectedItem && hasPermission(['CICLO_ORCAMENTARIO_EDITAR']) && (
                                                <UploadFile
                                                    hasFile={hasFile}
                                                    accept={'.xlsx'}
                                                    label="Incluir Taps"
                                                    id="importFilePlanilha"
                                                    selectedItem={selectedItem}
                                                />
                                            )}
                                        </Widget>
                                        {selectedItem && (
                                            <Widget>
                                                <Row>
                                                    <Col span={12}>
                                                        <CrfCicloOrcamentarioTable
                                                            titulo="Projetos Associados"
                                                            data={projetos || []}
                                                            handleJoinProjeto={handleJoinProjeto}
                                                            cicloOrcamentarioId={selectedItem && selectedItem.id}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Widget>
                                        )}
                                    </MasterDetailForm>
                                </GridView>
                            );
                        }}
                    </CrudContext.Consumer>
                )}
            </CompositeView>
        </CrudMasterDetailView>
    );
};

export default CrfCicloOrcamentarioComponent;
